import React from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { FILTER_SETTINGS } from '../../constants'
import StatusSelect from '../RightSideBar/information/StatusSelect'
import TagSelect from '../RightSideBar/information/TagSelect'
import GlobalSelect from '../common/GlobalSelect'
import DoubleRangeSlider from '../common/DoubleRangeSlider'
import FilterIcon from '../common/icons/FilterIcon'
import PaneHeader from './panes/PaneHeader'

const typeOptions = Object.entries(FILTER_SETTINGS.MAP_ITEM_TYPES).map(([key, value]) => ({
  value,
  label: value,
}))

const FilterPopup = ({ uiStore, dataStore, t }) => {
  const handleCloseClick = () => {
    uiStore.hideFilterPopup()
  }

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    uiStore.applyFilters()
    uiStore.expandTargetGroups()
    uiStore.resetBounds()
    uiStore.hideFilterPopup()
  }

  const handleReset = () => {
    uiStore.clearFilters()
    uiStore.resetBounds()
  }

  return (
    <div className='filter'>
      <PaneHeader
        icon={FilterIcon}
        title={t('MAP_FILTER.TITLE', { defaultValue: 'Filters' })}
        onClose={handleCloseClick}
      />
      <form className='filter__form' onSubmit={handleSubmit}>
        <ul className='filter__list'>
          <li className='filter__item' style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '0.5rem' }}>
            <GlobalSelect
              label='Type'
              value={typeOptions.find(opt => opt.value === (uiStore.filters.type.value || uiStore.filters.type)) || typeOptions[0]}
              defaultValue={typeOptions[0]}
              onChange={value => { uiStore.filters.type = value }}
              options={typeOptions}
              placeholder={typeOptions[0].label}
              className='filter__select'
            />
            <GlobalSelect
              label='Status'
              options={dataStore.statusOptions}
              defaultValue={dataStore.statusOptions[0]}
              placeholder={dataStore.statusOptions[0].label}
              className='filter__select'
              value={dataStore.statusOptions.find(opt => opt.value === uiStore.filters.statusValue) || dataStore.statusOptions[0]}
              onChange={value => { uiStore.filters.status = value }}
            />
          </li>
          <li className='filter__item'>
            <TagSelect
              options={dataStore.tagOptions}
              value={uiStore.filters.tags}
              onChange={selected => { uiStore.filters.tags = selected || [] }}
            />
          </li>
          <li className='filter__item'>
            <DoubleRangeSlider
              id='population'
              label='Population'
              inputKey='population'
              min={uiStore.filters.population.defaultMin}
              max={uiStore.filters.population.defaultMax}
              step={1}
            />
          </li>
          <li className='filter__item'>
            <DoubleRangeSlider
              id='density'
              label='Population density'
              inputKey='density'
              min={uiStore.filters.density.defaultMin}
              max={uiStore.filters.density.defaultMax}
              step={1}
            />
          </li>
          <li className='filter__item'>
            <DoubleRangeSlider
              id='avgAge'
              label='Average age'
              inputKey='avgAge'
              min={uiStore.filters.avgAge.defaultMin}
              max={uiStore.filters.avgAge.defaultMax}
              step={0.1}
            />
          </li>
          <li className='filter__item'>
            <DoubleRangeSlider
              id='genderRatio'
              label='Male / female ratio'
              inputKey='genderRatio'
              min={uiStore.filters.genderRatio.defaultMin}
              max={uiStore.filters.genderRatio.defaultMax}
              step={0.01}
            />
          </li>
          <li className='filter__item'>
            <DoubleRangeSlider
              id='income'
              label='Income'
              inputKey='income'
              min={uiStore.filters.income.defaultMin}
              max={uiStore.filters.income.defaultMax}
              step={1}
            />
          </li>
        </ul>
        <div className='filter__controls'>
          <div className='filter__controls-top'>
            <button type='button' className='filter__btn filter__btn--cancel' onClick={handleCloseClick}>{t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}</button>
            <button type='submit' className='filter__btn filter__btn--apply' onClick={handleSubmit}>{t('GLOBAL.APPLY', { defaultValue: 'Apply filters' })}</button>
          </div>
          <button type='button' className='filter__btn--reset' onClick={handleReset}>{t('MAP_FILTER.RESET', { defaultValue: 'Reset all filters' })}</button>
        </div>
      </form>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore')(observer(FilterPopup)))
